(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["delivery-timeline"] && !Shopify.designMode) return;
  try {
    (function () {
    var OPTS = { day: 'numeric', month: 'short' };

    function addDays(n) {
      var d = new Date();
      d.setDate(d.getDate() + n);
      return d;
    }

    function fmt(d) {
      return d.toLocaleDateString('en-IE', OPTS);
    }

    function fill(root) {
      if (root.dataset.dtlReady) return;
      root.dataset.dtlReady = '1';

      var ship = parseInt(root.dataset.shipDays, 10);
      var min = parseInt(root.dataset.deliverMin, 10);
      var max = parseInt(root.dataset.deliverMax, 10);
      if (isNaN(ship)) ship = 2;
      if (isNaN(min)) min = 9;
      if (isNaN(max)) max = 17;
      if (max < min) max = min;

      var confirmed = root.querySelector('[data-dtl-confirmed]');
      var shipped = root.querySelector('[data-dtl-shipped]');
      var delivered = root.querySelector('[data-dtl-delivered]');

      if (confirmed) confirmed.textContent = fmt(new Date());
      if (shipped) shipped.textContent = fmt(addDays(ship));

      if (delivered) {
        var a = addDays(min);
        var b = addDays(max);
        delivered.textContent =
          a.getMonth() === b.getMonth()
            ? a.toLocaleDateString('en-IE', { month: 'short' }) + ' ' + a.getDate() + ' - ' + b.getDate()
            : fmt(a) + ' - ' + fmt(b);
      }
    }

    function setup() {
      document.querySelectorAll('.dtl').forEach(fill);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setup);
    } else {
      setup();
    }
    document.addEventListener('shopify:block:select', setup);
    document.addEventListener('shopify:section:load', setup);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["faq"] && !Shopify.designMode) return;
  try {
    (function () {
    function setup(root) {
      if (root.dataset.pfaqReady) return;
      root.dataset.pfaqReady = '1';

      var items = root.querySelectorAll('.pfaq-item');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    }

    function init() { document.querySelectorAll('.pfaq').forEach(setup); }

    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:block:select', init);
    document.addEventListener('shopify:section:load', init);
    init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["size-chart-link"] && !Shopify.designMode) return;
  try {
    (function () {
    function close(m) {
      m.hidden = true;
      document.body.classList.remove('scl-locked');
    }

    function setup() {
      document.querySelectorAll('[data-scl-open]').forEach(function (btn) {
        if (btn.dataset.sclReady) return;
        btn.dataset.sclReady = '1';
        btn.addEventListener('click', function () {
          var m = document.getElementById(btn.getAttribute('data-scl-open'));
          if (!m) return;
          m.hidden = false;
          document.body.classList.add('scl-locked');
          var x = m.querySelector('.scl-x');
          if (x) x.focus();
        });
      });

      document.querySelectorAll('.scl-modal').forEach(function (m) {
        if (m.dataset.sclReady) return;
        m.dataset.sclReady = '1';
        m.querySelectorAll('[data-scl-close]').forEach(function (el) {
          el.addEventListener('click', function () { close(m); });
        });
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.scl-modal:not([hidden])').forEach(close);
    });

    document.addEventListener('DOMContentLoaded', setup);
    document.addEventListener('shopify:block:select', setup);
    document.addEventListener('shopify:section:load', setup);
    setup();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["size-finder-weight"] && !Shopify.designMode) return;
  try {
    (function () {
    function parseBands(raw) {
      // "S:60|M:70|L:80|XL:90|2XL:100|3XL:120" -> [{name, upTo}] sorted ascending
      return (raw || '')
        .split('|')
        .map(function (chunk) {
          var bits = chunk.split(':');
          return { name: (bits[0] || '').trim(), upTo: parseFloat(bits[1]) };
        })
        .filter(function (b) { return b.name && !isNaN(b.upTo); })
        .sort(function (a, b) { return a.upTo - b.upTo; });
    }

    function setup(root) {
      if (root.dataset.sfwReady) return;
      root.dataset.sfwReady = '1';

      var bands = parseBands(root.dataset.bands);
      if (!bands.length) return;

      var input = root.querySelector('[data-sfw-input]');
      var weightEl = root.querySelector('[data-sfw-weight]');
      var sizeEl = root.querySelector('[data-sfw-size]');
      if (!input || !sizeEl) return;

      function paint() {
        var kg = parseFloat(input.value);
        var min = parseFloat(input.min);
        var max = parseFloat(input.max);
        var pct = max > min ? ((kg - min) / (max - min)) * 100 : 0;

        input.style.background =
          'linear-gradient(90deg, var(--sfw-accent) 0%, var(--sfw-accent) ' +
          pct + '%, var(--sfw-track) ' + pct + '%, var(--sfw-track) 100%)';

        if (weightEl) weightEl.textContent = kg + ' kg';

        var match = bands[bands.length - 1];
        for (var i = 0; i < bands.length; i++) {
          if (kg <= bands[i].upTo) { match = bands[i]; break; }
        }
        sizeEl.textContent = match.name;
      }

      input.addEventListener('input', paint);
      input.addEventListener('change', paint);
      paint();
    }

    function init() {
      document.querySelectorAll('.sfw').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:block:select', init);
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["voice-note"] && !Shopify.designMode) return;
  try {
    (function () {
    function fmt(s) {
      if (!isFinite(s)) return '0:00';
      var m = Math.floor(s / 60), r = Math.floor(s % 60);
      return m + ':' + (r < 10 ? '0' : '') + r;
    }

    function setup(root) {
      if (root.dataset.vnReady) return;
      var audio = root.querySelector('[data-vn-audio]');
      if (!audio) return;
      root.dataset.vnReady = '1';

      var btn  = root.querySelector('[data-vn-play]');
      var bar  = root.querySelector('[data-vn-bar]');
      var fill = root.querySelector('[data-vn-fill]');
      var cur  = root.querySelector('[data-vn-cur]');
      var dur  = root.querySelector('[data-vn-dur]');

      audio.addEventListener('loadedmetadata', function () {
        dur.textContent = fmt(audio.duration);
      });

      audio.addEventListener('timeupdate', function () {
        cur.textContent = fmt(audio.currentTime);
        if (audio.duration) {
          fill.style.width = (audio.currentTime / audio.duration * 100) + '%';
        }
      });

      audio.addEventListener('ended', function () {
        root.classList.remove('is-playing');
        fill.style.width = '0%';
      });

      btn.addEventListener('click', function () {
        if (audio.paused) {
          document.querySelectorAll('.vn audio').forEach(function (other) {
            if (other !== audio) {
              other.pause();
              other.closest('.vn').classList.remove('is-playing');
            }
          });
          audio.play();
          root.classList.add('is-playing');
        } else {
          audio.pause();
          root.classList.remove('is-playing');
        }
      });

      var speeds = [1, 1.5, 2];
      var speedIndex = 0;
      var speedBtn = root.querySelector('[data-vn-speed]');
      if (speedBtn) {
        speedBtn.addEventListener('click', function () {
          speedIndex = (speedIndex + 1) % speeds.length;
          audio.playbackRate = speeds[speedIndex];
          speedBtn.textContent = speeds[speedIndex] + '\u00d7';
        });
      }

      bar.addEventListener('click', function (e) {
        if (!audio.duration) return;
        var r = bar.getBoundingClientRect();
        audio.currentTime = ((e.clientX - r.left) / r.width) * audio.duration;
      });
    }

    function init() { document.querySelectorAll('.vn').forEach(setup); }

    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:block:select', init);
    document.addEventListener('shopify:section:load', init);
    init();
  })();
  } catch(e) { console.error(e); }
})();

})();
